import React, { useEffect, useRef } from 'react';
import { LinkArrowIcon } from './icons/link-arrow-icon';


export const NavigationItems = (props: {
  activeIndex: number;
}) => {
  const { activeIndex } = props;
  const prevActiveIndex = useRef<number | null>(null);

  useEffect(() => {
    if (prevActiveIndex.current !== null) {
      prevActiveIndex.current = activeIndex;
    } else {
      prevActiveIndex.current = activeIndex;
    }
  }, [activeIndex]);

  const getClassName = (index: number) => {
    const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
    // @ts-ignore
    const direction = prevActiveIndex.current === null ? 'Default' : activeIndex > prevActiveIndex?.current ? 'up' : 'down';

    if (index === activeIndex) {
      return `active custom-animate__in${capitalize(direction)}`;
    } else if (index === prevActiveIndex.current) {
      return `prev custom-animate__out${capitalize(direction)}`;
    }

    return '';
  };

  return (
    <>
      <div className={`slide ${getClassName(0)}`}>
        <div className="text-block">
          <h1 className="title">
            ONE ECOSYSTEM
            <span className="highlight-title">EVERY TOOL A CREATOR NEEDS</span>
          </h1>
          <ul className="list-items">
            <li>Streaming, community, and monetization – all connected, all yours.</li>
            <li>Own your audience. Connect directly with fans. No middlemen, no platform politics.</li>
            <li>AI-native from day one, with custom agents built around your business.</li>
          </ul>
        </div>
      </div>

      <div className={`slide ${getClassName(1)}`}>
        <div className="text-block extra-margin--1">
          <h2 className="title">
            Streaming – You Create
            <span className="highlight-title">We Handle the Rest</span>
          </h2>
          <ul className="list-items">
            <li>A fully turnkey solution across web, app, and TV.</li>
            <li>AI-powered data analytics and automated customer service.</li>
            <li>Automatic revenue-share options between creators, platforms, and users.</li>
            <li>Social recommendations and affiliate rewards that improve engagement.</li>
          </ul>
          <a className="secondary-button" href="https://web.watchargo.com/" target="_blank" rel="noopener noreferrer">
            Watch on <img src="/images/argo.svg" alt="argo" className="button-logo" />
          </a>
        </div>
      </div>

      <div className={`slide ${getClassName(2)}`}>
        <div className="text-block extra-margin--1">
          <h2 className="title">
            YOUR COMMUNITY
            <span className="highlight-title">A HOME FOR YOUR FANS</span>
          </h2>
          <ul className="list-items">
            <li>Upgrade your website in minutes and bring your whole world together.</li>
            <li>All the tools to build, engage, and monetize – in one place.</li>
            <li>Stop renting your audience. Start owning it.</li>
          </ul>
          <div className="community-links">
            <a className="community-link" href="https://abrahamalexander.maji.la/" target="_blank" rel="noopener noreferrer">
              Abraham Alexander <LinkArrowIcon />
            </a>
            <a className="community-link" href="https://world.dorithmous.com/" target="_blank" rel="noopener noreferrer">
              Dorith Mous <LinkArrowIcon />
            </a>
            <a className="community-link" href="https://arcadiyg.com/" target="_blank" rel="noopener noreferrer">
              Arcadiy Community <LinkArrowIcon />
            </a>
          </div>
        </div>
      </div>

      <div className={`slide ${getClassName(3)}`}>
        <div className="text-block extra-margin--2">
          <h2 className="title">
            MAJI APP
            <span className="highlight-title">COMING SOON</span>
          </h2>
          <ul className="list-items">
            <li>A new way to connect around recommendations and content.</li>
            <li>Track what you watch. Follow who you love.</li>
            <li>One app for all your favorite creators.</li>
          </ul>
          <a className="primary-button reserve-nickname" href="https://passport.maji.la/auth/registration" target="_blank" rel="noopener noreferrer">
            Reserve your Nickname
          </a>
        </div>
      </div>
    </>
  );
}
